import {connect} from 'react-redux';
import Step17 from './Step17';
import {submitStep} from '../../actions/submitStep';

const mapStateToProps = ({
                           regType: {regType}
                         }) => ({
  regType,
});

export default connect(
  mapStateToProps,
  {submitStep}
)(Step17);
